import React, { Component, createRef } from 'react';
import { Dimensions, Platform, ScrollView, StatusBar, View } from 'react-native';
import Modal from 'react-native-modal';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import SpinnerOverlay from '@vfgroup-oneplatform/foundation/Components/SpinnerOverlay';
import StatusView from '@vfgroup-oneplatform/foundation/Components/StatusView/StatusView';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView, { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import FrameworkTestKeys from '../../FrameworkTestKeys';
import { getThemeImages } from '../../Themes';

import PrivacyPermissionsOverlayProps from './PrivacyPermissionsOverlay.context';
import { PageEnums } from './PrivacyPermissionsOverlay.Enums';
import styles from './PrivacyPermissionsOverlay.styles';
import { Intro, Privacy, Settings } from './Screens';

import _Modal from 'react-native-modal'


class PrivacyPermissionsOverlay extends Component {
  constructor(props) {
    super(props);

    this.scrollRef = createRef();

    this.state = {
      page: PageEnums.INTRO,
    };
  }

  onRejectAll = () => {
    _.isFunction(this.props.onRejectAll) && this.props.onRejectAll();
    this.goToPage(PageEnums.REJECT_SUCCESS);
  };

  onAcceptAll = async () => {
    this.goToPage(PageEnums.PROCESSING);

    const acceptRes = await this.props.onAcceptAll();
    this.goToPage(acceptRes ? PageEnums.ACCEPT_SUCCESS : PageEnums.ACCEPT_FAIL);
  };

  get colors() {
    return this.props.theme.colors;
  }

  get themeImages() {
    return getThemeImages(this.props.theme.name);
  }

  goToPage = page => {
    this.scrollRef.current?.scrollTo({ y: 0, animated: false });
    this.props.onPageChange?.(page);
    this.setState({ page });
  };

  renderProcessing = () => (
    <View testID={FrameworkTestKeys.PPOProcessing} style={styles.fullPage}>
      <VFLottieView
        autoPlay
        type={LottieTypes.spinner}
        style={styles.processingLottie}
        testID={FrameworkTestKeys.PPOLottie}
      />

      <VFText
        i18nKey="privacy_permissions_processing"
        style={[styles.processingText, { color: this.colors.loadingTextColor }]}
        testKey={FrameworkTestKeys.PPOProcessingText}
      />
    </View>
  );

  renderRejectAllSuccess = () => {
    const lottieProps = {
      type: 'tick',
      autoPlay: true,
      loop: false,
      lottieViewStyle: { width: 140, height: 140 },
    };
    return (
      <StatusView
        lottieProps={lottieProps}
        title="privacy_permissions_overlay_reject_all_success_modal_title"
        description="privacy_permissions_overlay_reject_all_success_modal_description"
        containerStyle={styles.successContainer}
        textStyles={{
          textContainer: styles.rejectAllModalTextContainer,
          title: styles.titleStyle,
          description: styles.descriptionStyle,
        }}
        primaryButtonProps={{
          title: 'privacy_permissions_overlay_reject_all_success_modal_primary_button',
          onPress: this.props.onDismiss,
        }}
        secondaryButtonProps={{
          title: 'privacy_permissions_overlay_reject_all_success_modal_secondary_button',
          onPress: this.props.onRejectAllManagePrivacy,
        }}
      />
    );
  };

  renderAcceptAllSuccess = () => {
    const lottieProps = {
      type: 'tick',
      autoPlay: true,
      loop: false,
      lottieViewStyle: { width: 140, height: 140 },
    };

    return (
      <StatusView
        testID={FrameworkTestKeys.PPOSuccess}
        lottieProps={lottieProps}
        title="privacy_settings_quick_action_title"
        description="privacy_permissions_accept_all_success_description"
        containerStyle={styles.successContainer}
        textStyles={{ textContainer: styles.successTextContainer }}
        primaryButtonProps={{
          testKey: FrameworkTestKeys.PPOReturnDashboard,
          title: 'privacy_permissions_dashboard_button',
          onPress: this.props.onDismiss,
        }}
        secondaryButtonProps={{
          testKey: FrameworkTestKeys.PPOManagePrivacy,
          title: 'privacy_permissions_manage_button',
          onPress: this.props.onAcceptAllManagePrivacy,
        }}
      />
    );
  };

  renderAcceptAllFail = () => {
    return (
      <StatusView
        testID={FrameworkTestKeys.PPOFail}
        image={this.themeImages.ic_WarningHiLight_Theme}
        title="privacy_settings_accept_all_error_screen_title"
        description="privacy_settings_accept_all_error_screen_message"
        containerStyle={styles.successContainer}
        textStyles={{ textContainer: styles.successTextContainer }}
        primaryButtonProps={{
          testKey: FrameworkTestKeys.PPOTryAgain,
          title: 'privacy_settings_accept_all_error_screen_button',
          onPress: () => this.goToPage(PageEnums.SETTINGS),
        }}
      />
    );
  };

  render() {

    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <_Modal
          isVisible={this.props.isVisible}
          backdropOpacity={0.5}
          onSwipeComplete={() => {
            this.props.onDismiss()
          }}
          onBackdropPress={() => {
            this.props.onDismiss()
          }}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: this.props.theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: '7px',
            }}
            onStartShouldSetResponder={() => true}>
            <StatusBar hidden />

            <PrivacyPermissionsOverlayProps.Provider value={this.props}>
              {this.props.isLoading && (
                <SpinnerOverlay isVisible autoPlay lottieStyle={styles.lottieStyle} />
              )}

              <ScrollView
                ref={this.scrollRef}
                style={styles.container(this.props.theme)}
                contentContainerStyle={styles.contentContainer}
                testID={FrameworkTestKeys.PPOModalScrollView}
              >
                {
                  {
                    [PageEnums.INTRO]: (
                      <Intro
                        goToPage={this.goToPage}
                        onRejectAll={this.onRejectAll}
                        onAcceptAll={this.onAcceptAll}
                      />
                    ),
                    [PageEnums.PRIVACY]: <Privacy goToPage={this.goToPage} />,
                    [PageEnums.SETTINGS]: <Settings goToPage={this.goToPage} />,
                    [PageEnums.PROCESSING]: this.renderProcessing(),
                    [PageEnums.REJECT_SUCCESS]: this.renderRejectAllSuccess(),
                    [PageEnums.ACCEPT_SUCCESS]: this.renderAcceptAllSuccess(),
                    [PageEnums.ACCEPT_FAIL]: this.renderAcceptAllFail(),
                  }[this.state.page]
                }
              </ScrollView>
            </PrivacyPermissionsOverlayProps.Provider>
          </View>
        </_Modal>
      );
    }
    return (
      <Modal
        visible={this.props.isVisible}
        animationType="slide"
        onRequestClose={this.props.onDismiss}
        style={styles.modalStyle(this.props.theme)}
        testID={FrameworkTestKeys.PPOModal}
      >
        <StatusBar hidden />

        <PrivacyPermissionsOverlayProps.Provider value={this.props}>
          {this.props.isLoading && (
            <SpinnerOverlay isVisible autoPlay lottieStyle={styles.lottieStyle} />
          )}

          <ScrollView
            ref={this.scrollRef}
            style={styles.container(this.props.theme)}
            contentContainerStyle={styles.contentContainer}
            testID={FrameworkTestKeys.PPOModalScrollView}
          >
            {
              {
                [PageEnums.INTRO]: (
                  <Intro
                    goToPage={this.goToPage}
                    onRejectAll={this.onRejectAll}
                    onAcceptAll={this.onAcceptAll}
                  />
                ),
                [PageEnums.PRIVACY]: <Privacy goToPage={this.goToPage} />,
                [PageEnums.SETTINGS]: <Settings goToPage={this.goToPage} />,
                [PageEnums.PROCESSING]: this.renderProcessing(),
                [PageEnums.REJECT_SUCCESS]: this.renderRejectAllSuccess(),
                [PageEnums.ACCEPT_SUCCESS]: this.renderAcceptAllSuccess(),
                [PageEnums.ACCEPT_FAIL]: this.renderAcceptAllFail(),
              }[this.state.page]
            }
          </ScrollView>
        </PrivacyPermissionsOverlayProps.Provider>
      </Modal>
    );
  }
}
PrivacyPermissionsOverlay.defaultProps = {
  theme: LightThemeColors,
};
PrivacyPermissionsOverlay.propTypes = {
  isVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onPageChange: PropTypes.func,
  onOkButtonPress: PropTypes.func.isRequired,
  introSections: PropTypes.array.isRequired,
  privacySettingsSections: PropTypes.array.isRequired,
  privacyPolicySections: PropTypes.array.isRequired,
  onRejectAll: PropTypes.func.isRequired,
  onRejectAllManagePrivacy: PropTypes.func.isRequired,
  onAcceptAll: PropTypes.func.isRequired,
  onAcceptAllManagePrivacy: PropTypes.func.isRequired,
  theme: PropTypes.object,
};

export default withTheme(PrivacyPermissionsOverlay);
